import React from 'react';
import { useParams } from 'react-router-dom';
import blogsData from '../data/blogs.json';
import BlogSection from './BlogSection';
import { slugify } from '../utils/slugify';
import SeoHelmet from './SeoHelmet';

const BlogDetails = () => {
  const { slug } = useParams();

  const blog = blogsData.blogs.find(blog => slugify(blog.title) === slug);

  if (!blog) {
    return (
      <div>
        <SeoHelmet title="Blog Not Found" robots="noindex, nofollow" path={`/blog/${slug}`} />
        Blog not found
      </div>
    );
  }

  const { title, description, image, date, content } = blog;
  const imageUrl = require(`../images/${image}`);
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    image: [`https://web5solution.com${imageUrl}`],
    datePublished: date,
    author: {
      "@type": "Organization",
      name: "Web5Solution",
    },
    publisher: {
      "@type": "Organization",
      name: "Web5Solution",
      logo: {
        "@type": "ImageObject",
        url: "https://web5solution.com/logo192.svg",
      },
    },
    mainEntityOfPage: `https://web5solution.com/blog/${slug}`,
  };

  return (
    <>
      <SeoHelmet
        title={title}
        description={description}
        path={`/blog/${slug}`}
        image={imageUrl}
        type="article"
        structuredData={articleSchema}
      />

      {/* BlogSection Component */}
      <BlogSection
        title={title}
        description={description}
        image={image}
        date={date}
        content={content}
      />
    </>
  );
};

export default BlogDetails;
